
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg","stroke":"#000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 30C8.268 30 2 23.73 2 16S8.268 2 16 2s14 6.27 14 14-6.268 14-14 14zm0-30C7.163 0 0 7.16 0 16s7.163 16 16 16 16-7.16 16-16S24.837 0 16 0zm5.717 10.28a1.014 1.014 0 00-1.425 0l-4.298 4.3-4.236-4.24a1 1 0 00-1.414 0 1.006 1.006 0 000 1.42l4.236 4.23-4.266 4.27a1.015 1.015 0 000 1.43c.394.39 1.032.39 1.426 0l4.266-4.27 4.236 4.24a1.002 1.002 0 101.415-1.42l-4.237-4.23 4.297-4.3c.393-.4.393-1.03 0-1.43z","fill":"#fff","stroke":"none","fill-rule":"evenodd"}})])
          )
        }
      }
    